import { FETCH_USERS_FAILED, FETCH_USERS_REQUESTED, FETCH_USERS_SUCCEEDED, UPDATE_CURRENT_PAGE, UPDATE_SORT_BY, sortByOptions } from "../constants"

const initialState = {
    loading: false,
    restaurants: [],
    totalCount: 0,
    itemsPerPage: 9,
    currentPageNumber: 1,
    sortBy: sortByOptions[1].displayText,
    error: ''
}

export const restaurantsReducer = (state = initialState, action) => {
    switch (action.type) {
        case FETCH_USERS_REQUESTED:
            return { ...state, loading: true }
        case FETCH_USERS_SUCCEEDED:
            return { ...state, loading: false, restaurants: action.payload.restaurants, totalCount: action.payload.totalCount }
        case FETCH_USERS_FAILED:
            return { ...state, loading: false, restaurants: [], error: action.payload, totalCount: 0 }
        case UPDATE_CURRENT_PAGE:
            return { ...state, currentPageNumber: action.payload }
        case UPDATE_SORT_BY:
            return { ...state, sortBy: action.payload }
        default: return state
    }
}